import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Lista de Contratações
    {
        path: '/contratacoes',
        name: 'listaContratacoes',
        component: () => import('@/modules/contratacao/views/listas/ListaContratacoesView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [
                ...COMMON_PERMISSIONS.ADMINISTRADORES,
                ...composePermissions('PESSOAL', 'COMPRAS', 'COORDENADOR', 'GESTAO', 'PROJETO', 'VISUALIZADOR_COMPRAS')
            ],
            isRotaOrigem: true,
        },
    },
    // Detalhe de Contratação
    {
        path: '/contratacao/:id',
        name: 'detalheContratacao',
        component: () => import('@/modules/contratacao/views/detalhes/DetalheContratacaoView.vue'),
        meta: {
            requiresAuth: true,
            temFilhas: true,
            allowedRoles: [
                ...COMMON_PERMISSIONS.ADMINISTRADORES,
                ...composePermissions('PESSOAL', 'COMPRAS', 'COORDENADOR', 'GESTAO', 'ORDENADOR', 'PROJETO', 'VISUALIZADOR_COMPRAS')
            ]
        },
        props: true,
        redirect: { name: 'dadosContratacao' },
        children: [
            {
                path: '/contratacao/:id/dados',
                name: 'dadosContratacao',
                component: () => import('@/modules/contratacao/components/tab/DetalheContratacao.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/contratacao/:id/propostas',
                name: 'propostasContratacao',
                component: () => import('@/modules/contratacao/components/tab/PropostasContratacao.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/contratacao/:id/resultados',
                name: 'resultadosContratacao',
                component: () => import('@/modules/contratacao/components/tab/ResultadosContratacao.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/contratacao/:id/notasfiscais',
                name: 'notasfiscaisContratacao',
                component: () => import('@/modules/contratacao/components/tab/NotasFiscaisContratacao.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/contratacao/:id/anexos',
                name: 'anexosContratacao',
                component: () => import('@/modules/contratacao/components/tab/AnexosContratacao.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/contratacao/:id/pareceres-juridicos',
                name: 'pareceresJuridicosContratacao',
                component: () => import('@/modules/contratacao/components/tab/PareceresJuridicosContratacao.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
        ]
    },
    // Cadastro de proposta de contratação
    {
        path: '/contratacao/:id/cadastroproposta',
        name: 'cadastrarPropostaContratacao',
        component: () => import('@/modules/contratacao/views/cadastros/CadastroContratacaoPropostaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.COMPRAS,
        },
        props: true
    },
    // Edição de proposta de contratação
    {
        path: '/contratacaoproposta/:idproposta',
        name: 'edicaoPropostaContratacao',
        component: () => import('@/modules/contratacao/views/cadastros/CadastroContratacaoPropostaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.COMPRAS,
        },
        props: true
    },
    // Detalhe de Proposta
    {
        path: '/detalheproposta/:id',
        name: 'detalheproposta',
        component: () => import('@/modules/contratacao/views/detalhes/DetalhePropostaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [
                ...COMMON_PERMISSIONS.ADMINISTRADORES,
                ...COMMON_PERMISSIONS.EQUIPE_GESTAO_PROJETOS,
                ...composePermissions('VISUALIZADOR_COMPRAS')
            ],
        },
        props: true
    },
    // Cadastro de Nota Fiscal
    {
        path: '/contratacao/:id/cadastronotafiscal',
        name: 'cadastroContratacaoNotaFiscal',
        component: () => import('@/modules/contratacao/views/cadastros/CadastroContratacaoNotaFiscalView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.COMPRAS,
        },
        props: true
    },
    // Lista de Atividades de Fornecedor
    {
        path: '/atividadesfornecedor',
        name: 'listaAtividadesFornecedor',
        component: () => import('@/modules/basicos/views/ListaAtividadeFornecedorView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.COMPRAS,
        },
    },
    // Lista de Fornecedores
    {
        path: '/fornecedores',
        name: 'listaFornecedores',
        component: () => import('@/modules/contratacao/views/listas/ListaFornecedorView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [
                ...COMMON_PERMISSIONS.ADMINISTRADORES,
                ...composePermissions('COMPRAS', 'GESTAO'),
            ],
        },
    },
    // Cadastro de Fornecedor
    {
        path: '/fornecedores/cadastro',
        name: 'cadastroFornecedor',
        component: () => import('@/modules/contratacao/views/cadastros/CadastroFornecedorView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.COMPRAS,
        },
        props: true
    },
    // Edição de Fornecedor
    {
        path: '/fornecedores/editar/:id',
        name: 'edicaoFornecedor',
        component: () => import('@/modules/contratacao/views/cadastros/CadastroFornecedorView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.COMPRAS,
        },
        props: true
    },
    // Detalhe de Solicitação para Compra
    {
        path: '/solicitacaocompras/:id',
        name: 'detalheSolicitacaoCompras',
        component: () => import('@/modules/contratacao/views/detalhes/DetalheSolicitacaoComprasView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.COMPRAS },
        props: true
    },
    // Lista de Solicitações para Compra
    {
        path: '/solicitacaocompras',
        name: 'listaSolicitacaoCompras',
        component: () => import('@/modules/contratacao/views/listas/ListaSolicitacaoComprasView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.COMPRAS, isRotaOrigem: true },
    },
    // Detalhe de Medição (Nota Fiscal/Recibo)
    {
        path: '/medicao/:id',
        name: 'detalheMedicao',
        component: () => import('@/modules/contratacao/views/detalhes/DetalheMedicaoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [
                ...COMMON_PERMISSIONS.ADMINISTRADORES,
                ...composePermissions('COMPRAS', 'GESTAO', 'ORDENADOR', 'PROJETO', 'VISUALIZADOR_COMPRAS')
            ],
        },
        props: true
    },
    // Lista de Medições Canceladas
    {
        path: '/medicoescanceladas',
        name: 'listaMedicoesCanceladas',
        component: () => import('@/modules/contratacao/views/listas/ListaMedicoesCanceladasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.COMPRAS, ...composePermissions('ORDENADOR', 'GESTAO'), ],
        },
    },
]